module.exports = __webpack_public_path__ + "static/projekt_indywidualny_c13-8d389e196c38bcb58366405dd49bbce0.jpg";